module.exports = "https://www.gc-pro.gnp.com.mx/ffff97e50e62dccef2d3bead0371b0ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/kmLogo.svg
// module id = 8143
// module chunks = 0